module.exports = __webpack_public_path__ + "static/media/tracker.f436fec2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/tracker.svg
// module id = 551
// module chunks = 0